<script setup>

import { defineProps, defineEmits} from "vue";
import CartaoDeContaAReceberAvulsa from "./CartaoDeContaAReceberAvulsa/CartaoDeContaAReceberAvulsa.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "vincularNotaFiscal",
    "controlesDesativados",
    "notasFiscaisVinculaveis",
    "dado",
    "recebimentoNovo",
    "contaAReceberValorOriginal",
    "contaAReceberValorVinculado",
    "contaAReceberSaldoAVincular",
    "notaFiscalEmitidaValorOriginal",
    "notaFiscalEmitidaValorRecebido",
    "notaFiscalEmitidaValorParaReceber",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraRecebimentoNovo",
    "update:autocalculaRecebimentoNovo",
]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//===================== Altera Recebimento Novo ====================//
//==================================================================//

const alteraRecebimentoNovo = (update)=>{

    emits('update:alteraRecebimentoNovo',update);

};

//==================================================================//
//================= Autocalcula Recebimento Novo ===================//
//==================================================================//

const autocalculaRecebimentoNovo = (update)=>{

    emits('update:autocalculaRecebimentoNovo',update);

};

</script>

<template>

    <div class="c-conteudo">

        <CartaoDeContaAReceberAvulsa
            :vincularNotaFiscal="props.vincularNotaFiscal"
            :controlesDesativados="props?.controlesDesativados"
            :notasFiscaisVinculaveis="props?.notasFiscaisVinculaveis"
            :dado="props?.dado"
            :recebimentoNovo="props?.recebimentoNovo"
            :contaAReceberValorOriginal="props?.contaAReceberValorOriginal"
            :contaAReceberValorVinculado="props?.contaAReceberValorVinculado"
            :contaAReceberSaldoAVincular="props?.contaAReceberSaldoAVincular"
            :notaFiscalEmitidaValorOriginal="props?.notaFiscalEmitidaValorOriginal"
            :notaFiscalEmitidaValorRecebido="props?.notaFiscalEmitidaValorRecebido"
            :notaFiscalEmitidaValorParaReceber="props?.notaFiscalEmitidaValorParaReceber"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraRecebimentoNovo="alteraRecebimentoNovo"
            @update:autocalculaRecebimentoNovo="autocalculaRecebimentoNovo"
        ></CartaoDeContaAReceberAvulsa>

    </div>

</template>

<style scoped>

.c-conteudo{
    display: grid;
    gap: 15px;
}

</style>